
    <div
      #container
      class="modal fade"
      style="display:block !important;"
      role="dialog"
    >
      <ng-container #element></ng-container>
    </div>
  